// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withIsVisible = require('client-v2/common/components/is-visible')
// Entry imports
const actions = require('client-v2/common/containers/auth-modal/actions')
const selectors = require('client-v2/common/containers/auth-modal/selectors')

function mapStateToProps(state) {
  if (!selectors.isVisible(state)) {
    return { isVisible: false }
  }
  const { authModal } = state
  return {
    errorProvider: authModal.errorProvider,
    errorType: authModal.errorType,
    isVisible: true
  }
}

const mapDispatchToProps = {
  onClose: actions.hide,
  onSocialProviderAuth: actions.socialAuth
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withIsVisible(
    require('./component-dumb')
  )
)
